import React from 'react';
import 'twin.macro';

interface Props {
  children: any;
  className?: string;
}

export function PageWrapper(props: Props) {
  const { children } = props;
  return (
    <div tw="h-full w-full md:pt-3 flex flex-col" className={props.className}>
      {children}
    </div>
  );
}

function Body(props: Props) {
  const { children, ...rest } = props;
  return (
    <div tw="grow w-full px-6 pt-2 lg:pt-8 overflow-y-auto" {...rest}>
      <div tw="max-w-5xl mx-auto">{children}</div>
    </div>
  );
}

PageWrapper.Body = Body;
